import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { HomeService } from 'src/app/services/home/home.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { ErrorComponent } from "../../layout/error/error.component";
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PostsService } from 'src/app/services/posts/posts.service';
import { PagesService } from 'src/app/services/pages/pages.service';
import { FileManagerComponent } from "../../layout/file-manager/file-manager.component";
@Component({
  selector: 'app-home',
  imports: [CommonModule, DragDropModule, SpinnerComponent, ErrorComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  data: any[] = []
  load = false
  loadUpdate = false

  error = false

  selected: any = null;
  isEdit = false
  editBtnLoad = false
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  form: FormGroup;

  selectedItems: any
  selectedItem: string = 'news'

  selectedPage: any
  selectLoad = false
  selecterror = false

  isSlider = false

  loadSave = false

  constructor(
    private HomeService: HomeService,
    private ToastrService: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private PostsService: PostsService,
    private PagesService: PagesService
  ){
    this.get()
    this.form = this.fb.group({
      id: [null],
      source: ['pages', Validators.required],
      tmp: ['cover', Validators.required],
      data_id: [0],
      redirect: null,
      redirect_en: null,
      items_limit: null,
      autoplay: null,
      visibility: [1],
      showtitle: null,
      new_window: null,
      border: null,
      title_image: null,
      title_position: null
    });

    this.getPageItems()
    this.getPage()

  }


  get(){
    this.load = true
    this.HomeService.getHome().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.data = res
        // თუ რომელიმე ელემენტში tmp არის 'slider', დააყენე isSlider = true
        this.isSlider = this.data.some(item => item.tmp === 'slider');
      },
      (error: any) => {
        this.load = false
        this.error = true
      }
    )
  }

  getPageItems(){
    this.selected = true
    this.PostsService.getPageItems().subscribe(
      (res: any) => {
        this.selectedItems = res;
        this.selected = false
        this.selecterror = false
      },
      (error: any) => {
        console.log(error)
        this.selected = false
        this.selecterror = true
      }
    );
  }

  getPage(){
    this.selected = true
    this.PagesService.getPagesAll().subscribe(
      (res: any) => {
        this.selectedPage = res;
        this.selecterror = false
        this.selected = false
      },
      (error: any) => {
        this.selecterror = true
        this.selected = false
      }
    );
  }

  onChange(){
    if(this.form.get('tmp').value == 'items'){
      this.getPageItems()
    }
    if(this.form.get('tmp').value == 'cover'){
      this.getPage()
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);

    // Update positions after reordering
    this.data = this.data.map((item, index) => ({
      ...item,
      position: index + 1
    }));

    // Optionally, send updated positions to backend:
    // this.HomeService.updatePositions(this.data).subscribe();
    this.loadUpdate = true
    this.HomeService.updatePositions(this.data).subscribe(
      (res: any) => {
        this.loadUpdate = false
        this.ToastrService.success('პოზიცია წარმატებით განახლდა')
      // console.log('Positions updated!');
    },
    (error: any) => {
      this.loadUpdate = false
      this.ToastrService.error('მოხდა შეცდომა პოზიციის განახლების დროს')

      // console.log(error)
    });

  }

  add(){
    this.selected = null;
    this.isEdit = false
    this.form.reset({
      id: null,
      source: 'pages',
      tmp: 'items',
      data_id: 0,
      redirect: null,
      redirect_en: null,
      items_limit: null,
      autoplay: null,
      visibility: 1,
      showtitle: null,
      new_window: null,
      border: null,
      title_image: null,
      title_position: null
    });

    this.modalService.open(this.formModalTemplate, { size: 'lg' });
  }

  edit(item: any){
    this.selected = item;
    this.isEdit = true
    // console.log(item)
    this.form.patchValue({
      id: item.id || null,
      source: item.source || 'pages',
      tmp: item.tmp || 'items',
      data_id: item.data_id || 0,
      redirect: item.redirect || null,
      redirect_en: item.redirect_en || null,
      items_limit: item.items_limit || null,
      autoplay: item.autoplay || null,
      visibility: item.visibility ?? 1,
      showtitle: item.showtitle ? 1 : 0,
      new_window: item.new_window ? 1 : 0,
      border: item.border ? 1 : 0,
      title_image: item.title_image ? 1 : 0,
      title_position: item.title_position || null
    });
    this.onChange()
    this.modalService.open(this.formModalTemplate, { size: 'lg' })
  }

    setCheckboxValue(controlName: string, checked: boolean) {
    this.form.get(controlName)?.setValue(checked ? 1 : 0);
  }

  save(modal: any){
    console.log(this.form.value)
    if(this.isEdit){
      this.loadSave = true
      this.HomeService.update(this.form.value).subscribe(
        (res: any) => {
          this.load = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
          modal.close();
        },
        (error: any) => {
          this.load = false
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }else {
      this.loadSave = true
      this.HomeService.add(this.form.value).subscribe(
        (res: any) => {
          this.load = false
          this.ToastrService.success('წარმატებით დაემატა')
          this.get()
          modal.close();
        },
        (error: any) => {
          this.load = false
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }
   

  }

  destroy(items: any){
    if(confirm('ნამდვილათ გსურთ წაშლა')){
      this.HomeService.delete(items.id).subscribe(
        (res: any) => {
          this.get()
          this.ToastrService.success('წარმატებით წაიშალა')
        },
        (error: any) => {
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }
    
  }






}
